var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3404 0.575995C22.3414 0.575995 27.2714 5.01299 28.1044 10.776H31.6404L25.6904 17.576L19.7404 10.776H23.6844C23.304 9.11187 22.3707 7.62586 21.0369 6.56062C19.703 5.49538 18.0474 4.91385 16.3404 4.91099C13.8754 4.91099 11.6994 6.11799 10.3224 7.937L7.41535 4.62199C8.52802 3.34964 9.90021 2.33026 11.4397 1.63238C12.9791 0.934495 14.6501 0.574296 16.3404 0.575995ZM15.6604 23.424C9.67635 23.424 4.72935 18.987 3.89635 13.224H0.360352L6.31035 6.42399C8.29935 8.68499 10.2714 10.963 12.2604 13.224H8.31635C8.69667 14.8881 9.62997 16.3741 10.9638 17.4394C12.2977 18.5046 13.9533 19.0861 15.6604 19.089C18.1254 19.089 20.3014 17.882 21.6784 16.063L24.5854 19.378C23.4738 20.6516 22.1018 21.6719 20.5621 22.3699C19.0224 23.0679 17.3509 23.4274 15.6604 23.424Z",
    fill: "#709CC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshBlue);
export default __webpack_public_path__ + "static/media/refresh-blue.47191c61ef52dfca89f6d04558867a21.svg";
export { ForwardRef as ReactComponent };